<div class="input-group">
    <!-- File input -->
    <input type="file" class="form-control" accept=".xls,.xlsx" id="formFile" (change)="onFileSelect($event)" #fileInput>

    <!-- Upload button -->
    <button class="btn btn-primary" type="button" (click)="upload()">
        <i class="bx bx-upload fs-19 ft-xl"></i>
    </button>
    <!-- <div class="input-group-append cursor-pointer">
        <span class="input-group-text" id="inputGroupFileAddon03">
            <a  title="Download Template">
                <i class="bx bx-download fs-19 ft-xl"></i>
            </a>
        </span>
    </div> -->
</div>